export const UPGRADE_DATA_INVALID = false;
export const UPGRADE_DATA_VALID = true;